import {
	Component,
	OnInit,
	Input,
	ViewChild,
	ElementRef,
	Output,
	HostBinding,
	AfterContentInit,
	ContentChildren,
	QueryList,
	EventEmitter
} from '@angular/core';
import { ButtonService } from 'src/app/services/button.service';

export type IconVariant = 'far' | 'fas' | 'fa';

@Component({
	selector: 'app-icon-button',
	templateUrl: './icon-button.component.html',
	styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent implements OnInit, AfterContentInit {
	@Input() contentClass = '';
	@Input() title: string;
	@Input() icon: string;
	@Input() size: string;
	@Input() mode: string;
	@Input() solid: string;
	@Input() function: string;
	@Input() disabled = false;
	@Input() set fa(mode: 's' | 'r' | '') {
		this.variant = ('fa' + mode) as IconVariant;
	}
	private variant: IconVariant = 'fa';
	private _toggleState: boolean = null;
	@Input('toggleState')
	set toggleState(state: boolean) {
		this._toggleState = state;
		this.buttonService.ToggleButton(this.btn.nativeElement, state);
	}
	get toggleState(): boolean {
		return this._toggleState;
	}
	@Input() dblfunction: string;
	@Input() bufferable = 'false';
	@Input() grouping: string;
	@Input() group: string;
	@Input() regular: string;
	@Input() toggleable: string;
	@Input() startHidden: string;
	@Input() toggleGroup: string;
	@Input() dropDownToggle: string;
	@Input() menu: string;
	@Input() autoFit: string;
	@Input() set isEnabled(val: any) {
		const enabled = ([false, 'false', 0, 'no', 'disabled'].indexOf(val) === -1);
		$(this.btn.nativeElement).attr('disabled', enabled ? '' : 'disabled');
		if (enabled) {
			$(this.btn.nativeElement).removeAttr('disabled');
		}

	}
	private _isOn = false;
	@Input()
	set isOn(on: boolean) {
		this.toggleButton.nativeElement.classList.toggle('primary', on === false);
		this.toggleButton.nativeElement.classList.toggle('secondary', on === true);
		if (this._isOn === on) {
			return;
		}

		this._isOn = on;
		this.isOnChange.emit(this._isOn);
	}
	get isOn(): boolean {
		return this._isOn;
	}
	@Output() isOnChange = new EventEmitter<boolean>();

	get isHidden(): boolean {
		if ($(this.element).css('display') === 'none') {
			return true;
		}
		if ($(this.btn.nativeElement).css('display') === 'none') {
			return true;
		}
		return false;
	}
	@Output() isHiddenChange = new EventEmitter();
	@HostBinding('class.button-group') get isDropdown() {
		return this.dropDownToggle;
	}
	@Output() click$ = new EventEmitter<MouseEvent>();
	@Output() ready = new EventEmitter<string>();
	@ViewChild('button1', { static: true }) button1: ElementRef<HTMLButtonElement>;
	@ViewChild('btn', { static: true }) btn: ElementRef;
	@ViewChild('btnSpan', { static: true }) btnSpan: ElementRef;
	@ViewChild('btnContent', { static: true }) btnContent: ElementRef;
	@ViewChild('toggleButton', { static: true }) toggleButton: ElementRef;
	@ViewChild('dropDownContent', { static: true }) dropDownContent: ElementRef;
	@ContentChildren(IconButtonComponent) buttons!: QueryList<IconButtonComponent>;
	constructor(private buttonService: ButtonService, private domNode: ElementRef) { }
	get element(): HTMLElement {
		return this.domNode.nativeElement;
	}

	get content(): string {
		return this.btnContent.nativeElement.innerHTML;
	}
	public groupingMode = '';

	HasDoubleFunction() {
		if (!this.dblfunction) { return false; }
		if (this.dblfunction === '') { return false; }
		if (this.dblfunction === undefined) { return false; }
		if (this.dblfunction === null) { return false; }
		return ('' + this.dblfunction) !== '';
	}

	ngOnInit() {
		this.buttonService.SetupFAIconButton(this.btn.nativeElement as HTMLButtonElement, this.btnSpan.nativeElement,
			this.title, this.icon, this.size, this.mode, this.solid, this.regular, this.toggleable, this.startHidden, this.menu);
		if (!!this.function) {
			$(this.btn.nativeElement).attr('data-action', this.function);
		}

		if (this.dropDownToggle === 'true') {
			// $(this.btn.nativeElement).toggleClass('dropdown-toggle', true);
			// $(this.btn.nativeElement).attr('data-toggle', 'dropdown');
			$(this.domNode.nativeElement).toggleClass('dropdown', true);
			$(this.btnContent.nativeElement).children().appendTo(this.dropDownContent.nativeElement);
			if (this.icon === '') {
				$(this.btnSpan.nativeElement).toggleClass('hidden', true);
			}
		} else {
			$(this.btnSpan.nativeElement).toggleClass('hidden', false);
		}
		if (this.toggleable !== 'false') {
			$(this.btn.nativeElement).on('click', () => {
				window.requestAnimationFrame(() => {
					this.isOn = $(this.btn.nativeElement).attr('data-on-state') === 'on';
					this.isOnChange.emit(this.isOn);
				})

			});
		}

		$(this.btn.nativeElement).toggleClass('width-fit-content', this.autoFit === 'true');
		this.isHiddenChange.emit(this.isHidden);
		if (this._toggleState !== null) {
			this.Toggle(this._toggleState, false);
		}
	}

	ngAfterContentInit(): void {
		this.ready.emit('ready');
		if (this.btnContent.nativeElement.children.length > 0) {
			this.button1.nativeElement.classList.toggle('w_sub-icon', true);
		}

	}
	ToggleClass(className: string, onOff: boolean) {
		$(this.domNode.nativeElement).toggleClass(className, onOff);
		this.isHiddenChange.emit(this.isHidden);
	}
	IsSelected() {
		return $(this.btn.nativeElement).hasClass('btn-secondary');
	}
	ChangeIcon(iconName: string) {
		const target = $(this.btnSpan.nativeElement);

		if (!!target) {


			if (this.icon !== undefined) {
				if (this.icon.substr(0, 3) !== 'sl-') {
					target.toggleClass('fa-' + this.icon, false);
					target.toggleClass('fa', false);
				} else {

					target.toggleClass(this.icon, false);
				}
			}

			this.icon = iconName;
			if (this.icon.substr(0, 3) !== 'sl-') {
				target.toggleClass('fa-' + this.icon, true);
				target.toggleClass('fa', true);
			} else {
				target.toggleClass(this.icon, true);
			}
			if (this.solid) {
				target.toggleClass('fa',false);
			}
		}
		if (this.icon === '') {
			$(this.btnSpan.nativeElement).toggleClass('hidden', true);
		} else {
			$(this.btnSpan.nativeElement).toggleClass('hidden', false);
		}
		this.isHiddenChange.emit(this.isHidden);
	}
	ChangeMode(mode: any) {
		const button = $(this.btn.nativeElement);
		button.toggleClass('btn-primary', false);
		button.toggleClass('btn-secondary', false);
		button.toggleClass('btn-secondary-primary', false);
		button.toggleClass('btn-danger', false);
		button.toggleClass('btn-secondary-danger', false);
		button.toggleClass('btn-warn', false);
		button.toggleClass('btn-' + mode, true);
		if ((this.dropDownToggle === 'true') && (this.toggleable !== 'on')) {
			const ddButton = $(this.toggleButton.nativeElement);
			ddButton.toggleClass('btn-primary', false);
			ddButton.toggleClass('btn-secondary', false);
			ddButton.toggleClass('btn-secondary-primary', false);
			ddButton.toggleClass('btn-danger', false);
			ddButton.toggleClass('btn-secondary-danger', false);
			ddButton.toggleClass('btn-warn', false);
			ddButton.toggleClass('btn-' + mode, true);
		}

	}
	ChangeContent(content: string) {
		this.btnContent.nativeElement.innerHTML = content;
	}
	Enable() {
		(this.btn.nativeElement as HTMLButtonElement).disabled = false;
	}
	Disable() {
		(this.btn.nativeElement as HTMLButtonElement).disabled = true;
	}
	ClickHandler(event: MouseEvent) {
		this.click$.emit(event);

	}

	Toggle(optOnOff: boolean = null, optNotify: boolean = true) {
		this.buttonService.ToggleButton(this.btn.nativeElement, optOnOff);
		this.isOn = $(this.btn.nativeElement).hasClass('btn-secondary');
		if (optNotify === true) {
			this.isOnChange.emit(this.isOn);
		}
	}
	GetDropDownButtons(): Array<IconButtonComponent> {
		return this.buttons.toArray();
	}
}
